import type { ReportEntity, SprintEntity } from '@data/utils/types';
import { fullDate } from '@app/utils/helpers/date-utils';

/** The span a year of sprints covers, as the product reports route takes it. */
export const sprintSpan = (sprints: SprintEntity[]): { from: string; to: string } | null =>
  sprints.length
    ? {
        from: sprints.map(sprint => fullDate(sprint.startDate)).sort()[0],
        to: sprints
          .map(sprint => fullDate(sprint.endDate))
          .sort()
          .reverse()[0],
      }
    : null;

/** Each sprint's entries, start and end day included, as the per-sprint route picks them; incident work or the rest. */
export const reportsBySprint = (
  reports: ReportEntity[],
  sprints: SprintEntity[],
  { incidentWork }: { incidentWork: boolean },
): Record<string, ReportEntity[]> => {
  const kept = reports.filter(report => !!report.incidentId === incidentWork);
  return Object.fromEntries(
    sprints.map(sprint => {
      const from = fullDate(sprint.startDate);
      const to = fullDate(sprint.endDate);
      return [sprint.id, kept.filter(report => fullDate(report.workday) >= from && fullDate(report.workday) <= to)];
    }),
  );
};
